<style>
@import '../../css/common.css';
.modal-abso{
    position:fixed;
    background-color: rgba(0, 0, 0, 0.05);
    margin:auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000;
    overflow-y: auto;
    /*opacity: 0.2;*/
    /*right: -15px;*/
    /*overflow-y:auto;*/
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-content{
    width: 700px;
    margin-top: 30%;
/*    margin-left: 50%;
    margin-left: 70px;*/
    background-color: #393e46;
}
.modal-title{
    color: #fff;
    text-align: left!important;
}
.modal-header,.modal-footer{
    border-bottom: 1px @border-color solid;
    border-top: 1px @border-color solid;
}
.item-title{
    text-align: left;
}
table td{
    text-align: center;
}
.bdt{
    border-top: 1px solid #222831!important;
}
.bdb{
    border-bottom: 1px solid #222831;
    height: 50px;
}
</style>
<template>
	<div class="modal-abso" :class="isShow ? '' : 'hide'">
		<div class="modal-dialog" style="margin-top:200px;">
			<div class="modal-content">
                <div class="modal-header clearfix" style="border-bottom:1px solid #ccc;">   
                     <div class="pull-right">
                        <button type="button" class="close" @click="close()">                        
                            <span aria-hidden="true">×</span><span class="sr-only">Close</span>
                        </button>
                    </div>                   
                    <div class="pull-right pr15">
                         <slot name="top"></slot>
                    </div>             
                    <h4 class="modal-title">
                        <span>{{title}}</span>
                    </h4>
                </div>
				<div class="modal-body pb0">
                    <slot></slot>
                </div>
                <div class="modal-footer" style="border-top:1px solid #ccc;">
                    <slot name="button"></slot>
                    <button type="button" class="btn btn-line" @click="close()" v-else>关闭</button>
                </div>
			</div>
		</div>
	</div>
</template>
<script>
	/**
	* 弹窗
	*/
	module.exports = {
        props : ['title'],
		data : function(){
            return {
                isShow : false,
                show : function(){
                    this.isShow = true;
                },
                close : function(){
                    this.isShow = false;
                    this.$dispatch('modalClose');
                }
            }
        },
        ready: function() {
        },
        events : {
            /**
            * 广播通知下的窗口关闭
            */
            modalDialogClose : function () {
                this.close();
            },
            modal: function(bool) {
                this.isShow = bool;
            }
        }
	};
</script>


/** WEBPACK FOOTER **
 ** BaseModel.vue?1ddc01b1
 **/